import { ColumnsType } from 'antd/es/table'
import { Table } from 'antd/lib'
import { t } from 'i18next'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { styled } from 'styled-components'
import { SectionLoadingState } from '../../../../components'
import { NO_DATA_PLACEHOLDER } from '../../../../constants/constants'
import { useAlgorithmRunDetails } from '../../../../hooks'
import useWorkspaceDetails from '../../../../hooks/useWorkspaceDetails'
import {
  FlowCytometryNodeResult,
  FlowCytometryReviewAnalysisRunResult,
  ReviewAnalysisCompensationMatrixReviewRow,
} from '../../../../store/reducers/workspaceReducer'
import { SmartFunctionListPanelLayout } from '../../components/SmartFunctionListPanelLayout'

const SectionLoadingStateContainer = styled.div`
  display: flex;
  height: calc(100vh - 224px);
`

interface ExtendedReviewAnalysisCompensationMatrixReviewRow extends ReviewAnalysisCompensationMatrixReviewRow {
  key: string
}

const FlowCytometryReviewAnalysisCompensationMatrixReviewPanel = () => {
  const { workspaceId, algorithmRunId } = useParams()

  const { selectedWorkspace } = useWorkspaceDetails({
    workspaceId,
    preventFetch: true,
  })

  const { loading, selectedAlgorithmRun } = useAlgorithmRunDetails({
    workspaceId,
    algorithmRunId,
    preventFetch: false,
  })

  console.log('Temporary line', selectedWorkspace, selectedAlgorithmRun)

  const nodeResults = useMemo(
    () =>
      selectedAlgorithmRun?.nodeResults
        ? ((selectedAlgorithmRun?.nodeResults as FlowCytometryNodeResult)
            ?.REVIEW_ANALYSIS as FlowCytometryReviewAnalysisRunResult)
        : undefined,
    [selectedAlgorithmRun],
  )

  const formattedData: ExtendedReviewAnalysisCompensationMatrixReviewRow[] =
    useMemo(
      () =>
        nodeResults && nodeResults.compensationMatrixReview
          ? nodeResults.compensationMatrixReview.map(
              (gate: ReviewAnalysisCompensationMatrixReviewRow) =>
                ({
                  ...gate,
                  key: gate.patientId,
                }) as ExtendedReviewAnalysisCompensationMatrixReviewRow,
            )
          : [],
      [nodeResults],
    )

  // const formattedData: ExtendedReviewAnalysisCompensationMatrixReviewRow[] = [
  //   {
  //     key: '1',
  //     patientId: 'A01-002',
  //     filename: 'ADO0007P0007P_CTRL_A_F10_006.fcs',
  //     cytometerId: 'hard coded id',
  //     matrixNameFound: 'matric name',
  //     flagMessage:
  //       'Polygon bounding box differs on both X and Y axes by more than 5.0%.',
  //   },
  // ]

  const columns: ColumnsType<ReviewAnalysisCompensationMatrixReviewRow> =
    useMemo(
      () => [
        {
          title: t(
            'smartFunctionDetailsPage.cellCartaFlowCytometryReviewAnalysis.tableTitles.patientId',
          ),
          dataIndex: 'patientId',
          key: 'patientId',
          width: '10%',
          render: (text, record) => <>{text || NO_DATA_PLACEHOLDER}</>,
        },
        {
          title: t(
            'smartFunctionDetailsPage.cellCartaFlowCytometryReviewAnalysis.tableTitles.filename',
          ),
          dataIndex: 'filename',
          key: 'filename',
          width: '25%',
          render: (text, record) => <>{text || NO_DATA_PLACEHOLDER}</>,
        },
        {
          title: t(
            'smartFunctionDetailsPage.cellCartaFlowCytometryReviewAnalysis.tableTitles.cytometerId',
          ),
          dataIndex: 'cytometerId',
          key: 'cytometerId',
          width: '10%',
          render: (text, record) => <>{text || NO_DATA_PLACEHOLDER}</>,
        },
        {
          title: t(
            'smartFunctionDetailsPage.cellCartaFlowCytometryReviewAnalysis.tableTitles.matrixNameFound',
          ),
          dataIndex: 'matrixNameFound',
          key: 'matrixNameFound',
          width: '25%',
          render: (text, record) => <>{text || NO_DATA_PLACEHOLDER}</>,
        },
        {
          title: t(
            'smartFunctionDetailsPage.cellCartaFlowCytometryReviewAnalysis.tableTitles.flagMessage',
          ),
          dataIndex: 'flagMessage',
          key: 'flagMessage',
          width: '30%',
          render: (text, record) => <>{text || NO_DATA_PLACEHOLDER}</>,
        },
      ],
      [],
    )

  return loading ? (
    <SectionLoadingStateContainer>
      <SectionLoadingState />
    </SectionLoadingStateContainer>
  ) : (
    <SmartFunctionListPanelLayout>
      <Table
        columns={columns}
        dataSource={formattedData}
        loading={loading}
        rowKey="key"
        pagination={false}
        scroll={{ y: 'calc(100vh - 190px)' }}
        rowClassName="page-list-table-row"
      />
    </SmartFunctionListPanelLayout>
  )
}

export default FlowCytometryReviewAnalysisCompensationMatrixReviewPanel
